import ProfileSummaryForm from '@/components/Forms/ProfileSummaryForm';
import { updateProfileSummary } from '@/store/services/userServices';
import { useGetMe } from '@/hooks/useGetMe';

const ProfileSummaryModal = ({ onClose, preSaved, onOutsideClick }) => {
  const { profile, refetchProfile } = useGetMe();

  const onSubmit = values => {
    const payload = {
      company_name: values.company_name,
      position: values.position,
    };

    updateProfileSummary(payload).then(res => {
      if (res && res.success) {
        refetchProfile();
        onClose();
      }
    });
  };

  const handleOutsideClick = values => {
    onOutsideClick && onOutsideClick(values);
    onClose();
  };

  return (
    <ProfileSummaryForm
      user={profile}
      onSubmit={onSubmit}
      onCancel={onClose}
      preSaved={preSaved}
      onOutsideClick={handleOutsideClick}
    />
  );
};

export default ProfileSummaryModal;
